import { graphql } from "~/gql";

export const UPDATE_PHASE = graphql(/* GraphQL */ `
  mutation updatePhase($phaseId: Int!, $matterId: Int!, $data: PhaseUpdateInput!) {
    updatePhase(phaseId: $phaseId, matterId: $matterId, data: $data) {
      ...PhaseParts
    }
  }
`);

export const UPDATE_PHASES = graphql(/* GraphQL */ `
  mutation updatePhases($data: [UpdatePhasesInput!]!, $matterId: Int!) {
    updatePhases(data: $data, matterId: $matterId) {
      ...PhaseParts
    }
  }
`);
